import {
    IBusinessObject,
    IBusinessObjectChanges,
    IBusinessObjectChangesOptions,
    IBusinessObjectCreateLoadOptions
} from '../PA.Core/PA.Core.IF.BO';
import {IMessageProvider, IProgressProvider, MessageType} from '../PA.Core/PA.Core.IF.Basic';
import {PAdbContext} from '../PA.Core/PAdbContext';
import {IdentityProvider} from "../PA.Core/Basic/Identity";
import {
    WB_MasterDataSetRow, WB_SalesOrgRow,
    WB_UserGroupHierarchyRow,

} from "../PA.Core/PAdbSchemaRows";
import {ProgressProvider} from "../PA.Core/Basic/Progress";
import {MessageProvider} from "../PA.Core/Basic/Messages";
import {
    esWB_MasterData_Set, esWB_SalesOrg,
    esWB_User_Group,
    esWB_User_Group_Hierarchy,
} from "../PA.Core/PAdbSchema";
import {ASync} from "../PA.Core/Basic/ASync";
import {CreateOptions, ESRecordResolver} from "../PA.Core/lib/ESRecordResolver";
import { IwbUserGroupHierarchy} from "../PA.Core/PAdbSchemaRowsIF";
import {ESRecord} from "../PA.Core/lib/ESRecord";
import {ESDataStore} from "../PA.Core/lib/ESDataStore";
import _ = require('lodash');
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import {DefaultChanges} from "../PA.Core/BusinessObject/BusinessObjectChanges";
import {UserGroupHierarchyBOValidations} from "./UserGroupHierarchyBO.Validation";


export class UserGroupHierarchyBO implements IBusinessObject {

    Identity: IdentityProvider;


    CreateOptions: any;

    LoadOptions: any;
    _bIsLoaded: boolean;
    _OnLoadComplete: Promise<IBusinessObject>;
    LoadProgressProvider: IProgressProvider;

    ValidateOptions: any;
    _bIsValidated: boolean;
    ValidateMessageProvider: IMessageProvider;
    ValidateProgressProvider: IProgressProvider;

    SaveOptions: any;
    _bIsSaved: boolean;
    SaveProgressProvider: IProgressProvider;

    DeleteOptions: any;
    _bIsDeleted: boolean;
    DeleteMessageProvider: IMessageProvider;
    DeleteProgressProvider: IProgressProvider;

    dbContext: PAdbContext;
    drWB_UserGroupHierarchy: WB_UserGroupHierarchyRow;

    dctAuditedDeletes: {[id:number]: number}
    constructor(options?: IBusinessObjectCreateLoadOptions) {

        this.CreateOptions = options || {};

        if ('dbContext' in this.CreateOptions)
            this.dbContext = this.CreateOptions.dbContext;

        this.Identity = new IdentityProvider({id: 0, name: 'New User Group Hierarchy'});

        this.LoadOptions = {};
        this._bIsLoaded = false;
        this._OnLoadComplete = undefined;
        this.LoadProgressProvider = new ProgressProvider('Loading', this);

        this.ValidateOptions = {};
        this._bIsValidated = false;
        this.ValidateMessageProvider = new MessageProvider();
        this.ValidateProgressProvider = new ProgressProvider("Validating", this);

        this.SaveOptions = {};
        this._bIsSaved = false;
        this.SaveProgressProvider = new ProgressProvider("Saving", this);

        this.DeleteOptions = {};
        this._bIsDeleted = false;
        this.DeleteMessageProvider = new MessageProvider();
        this.DeleteProgressProvider = new ProgressProvider("Deleting", this);

        this.drWB_UserGroupHierarchy = undefined;

        this.dctAuditedDeletes = {}

    }

    get WB_UserGroupHierarchy(): WB_UserGroupHierarchyRow {
        return this.drWB_UserGroupHierarchy;
    }



    //<editor-fold desc = "IBusinessObject operations">


    Copy(options?: any): Promise<IBusinessObject> {
        return undefined;
    }

    LoadNew(options?: IBusinessObjectCreateLoadOptions): Promise<IBusinessObject> {
        const self = this;
        this.LoadProgressProvider.start("Creating User Group Hierarchy");

        let internalOnComplete = self._OnLoadComplete = (async() => {
            try{

                self.LoadOptions = options || {};
                if ('dbContext' in self.LoadOptions)
                    self.dbContext = self.LoadOptions.dbContext;
                else
                    self.dbContext = new PAdbContext();

                if (this.dbContext == null) {
                    var sError = "Unable to determine dbContext for new User Group Hierarchy.";
                    self.LoadProgressProvider.exception(sError);
                    return self;
                }

                // Create record using dbContext
                let newUserGroupHierarchy: WB_UserGroupHierarchyRow=<WB_UserGroupHierarchyRow>await this.dbContext.createRecordWithKey(esWB_User_Group_Hierarchy)
                newUserGroupHierarchy.setDefaults()
                self.drWB_UserGroupHierarchy = newUserGroupHierarchy;
                self.dbContext.add(esWB_User_Group, newUserGroupHierarchy)
                self.Identity.setAll(self.WB_UserGroupHierarchy.cif.WB_USRGRPH_ID, self.WB_UserGroupHierarchy.cif.USRGRPH_ID, self.WB_UserGroupHierarchy.cif.USRGRPH_NAME);
                self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
                self.LoadProgressProvider.finish();
                self._bIsLoaded = true;
                self._OnLoadComplete = null;
                await self.applyCreateOptions()
                self.Identity.setAll(self.WB_UserGroupHierarchy.cif.WB_USRGRPH_ID, self.WB_UserGroupHierarchy.cif.USRGRPH_ID, self.WB_UserGroupHierarchy.cif.USRGRPH_NAME);
                self.Identity.listenToRecordUpdates(self.WB_UserGroupHierarchy, 'WB_USRGRPH_ID', 'USRGRPH_ID', 'USRGRPH_NAME')

                self.LoadProgressProvider.finish();
                self._bIsLoaded = true;
                self._OnLoadComplete = null;
                return self;
            } catch(err ) {
                self.LoadProgressProvider.exception(err);
                return self
            }})();

        return internalOnComplete;
    }

    async applyCreateOptions(){
        const self = this

        let sId = self.CreateOptions?.sId || self.LoadOptions?.sId
        if (!_.isEmpty(sId))
            self.WB_UserGroupHierarchy.cif.USRGRPH_ID = sId

        let sName = self.CreateOptions?.sName || self.LoadOptions?.sName
        if (!_.isEmpty(sName))
            self.WB_UserGroupHierarchy.cif.USRGRPH_NAME = sName

        // Set the MD Set
        let wbMasterDataSetID = self.CreateOptions?.wbMasterDataSetId || self.LoadOptions?.wbMasterDataSetId
        if(_.isNumber(wbMasterDataSetID)){
                let mdset: WB_MasterDataSetRow = <any> await self.dbContext.find(esWB_MasterData_Set,wbMasterDataSetID)
                if(mdset){
                    self.WB_UserGroupHierarchy.cif.WB_MDSET_ID = wbMasterDataSetID
                    self.WB_UserGroupHierarchy.WB_MasterDataSetRow = mdset
                }
        }

        // Set the Sales Org
        let wbSalesOrgId = self.CreateOptions?.wbSalesOrgId || self.LoadOptions?.wbSalesOrgId
        if(_.isNumber(wbSalesOrgId)){
            let salesOrg: WB_SalesOrgRow = <any> await self.dbContext.find(esWB_SalesOrg, wbSalesOrgId)
            if(salesOrg){
                self.WB_UserGroupHierarchy.cif.WB_SALESORG_ID = wbSalesOrgId
                self.WB_UserGroupHierarchy.WB_SalesOrgRow = salesOrg
            }
        }


    }

    Load(anId: number | number, options?: IBusinessObjectCreateLoadOptions): Promise<IBusinessObject> {

        const self = this;

        let recordResolver: ESRecordResolver
        let recordResolverLoadPromise: Promise<void>

        self.LoadProgressProvider.start("Loading (" + anId + ")");

        self._OnLoadComplete = new Promise<IBusinessObject>((resolve, error) => {

            if (self.bIsLoaded) {
                self.LoadProgressProvider.exception("User Group Hierarchy already loaded.")
                resolve(self); // "User Group Hierarchy already loaded.";
                return;
            }

            self.LoadOptions = options || {};



            if ('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else if (_.isEmpty(self.dbContext)) {
                self.dbContext = new PAdbContext({});
            }

            if (_.isEmpty(self.dbContext)) {
                error("Unable to determine dbContext for User Group Hierarchy.")
                return;
            }

            if ('RecordResolver' in self.LoadOptions) {
                recordResolver = (<any>self.LoadOptions).RecordResolver
                recordResolverLoadPromise = ASync.resolve()
            } else {
                recordResolver = UserGroupHierarchyBO.createRecordResolver({dbContext: self.dbContext})
                recordResolverLoadPromise = UserGroupHierarchyBO.setupRecordResolver(recordResolver, [anId])
            }


            recordResolverLoadPromise
                .then(function () {
                    let aUserGroupHierarchyRow: any = recordResolver.get(esWB_User_Group_Hierarchy, anId)

                    if (_.isEmpty(aUserGroupHierarchyRow)) {
                        error("User Group Hierarchy not Found");
                        return;
                    }

                    self.drWB_UserGroupHierarchy = aUserGroupHierarchyRow;
                    self.Identity.setAll(self.WB_UserGroupHierarchy.cif.WB_USRGRPH_ID, self.WB_UserGroupHierarchy.cif.USRGRPH_ID, self.WB_UserGroupHierarchy.cif.USRGRPH_NAME);
                    self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
                    self.Identity.listenToRecordUpdates(self.WB_UserGroupHierarchy, 'WB_USRGRPH_ID', 'USRGRPH_ID', 'USRGRPH_NAME')
                    self._bIsLoaded = true
                    self._OnLoadComplete = undefined
                    self.LoadProgressProvider.finish()
                    resolve(self)
                }).catch(function (err: any) {
                self._OnLoadComplete = undefined
                self.LoadProgressProvider.exception(err)
                error(err)
                return;
            });

        });

        return this._OnLoadComplete;
    }

    get OnLoadComplete(): Promise<IBusinessObject> {
        return this._OnLoadComplete;
    }

    get bIsLoaded(): boolean {
        return this._bIsLoaded;
    }

    async Validate(options?: any): Promise<IBusinessObject> {

        var self = this;
        try {
            this.ValidateMessageProvider.clearMessages();
            this.ValidateProgressProvider.start("Validating " + self.WB_UserGroupHierarchy.cif.USRGRPH_NAME + "(" + self.WB_UserGroupHierarchy.cif.USRGRPH_ID + ")");

            // Does no validations yet
            self.ValidateOptions = options || {};

            if (self.dbContext == undefined) {
                var sError = "Unable to determine dbContext for to Validate User Group Hierarchy.";
                self.ValidateProgressProvider.exception(sError);
                throw new Error(sError)
            }

                    await UserGroupHierarchyBOValidations.Validate(self)

                    if (self.ValidateMessageProvider.countMessages(MessageType.Error) > 0) {
                        self._bIsValidated = false;
                    } else {
                        self._bIsValidated = true;
                    }
                    self.ValidateProgressProvider.finish();
                    return self;

        } catch (err) {
            self._bIsValidated = false
            self.ValidateProgressProvider.exception(err)
            return self

        }
    }

    get bIsValidated(): boolean {
        return this._bIsValidated;
    }


    Save(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(false, options)
    }


    SaveBatch(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(true, options)
    }

    async SaveUsing(bBatch: boolean, options?: any): Promise<IBusinessObject> {

        var self = this;
        var wbUsrGrpH = <IwbUserGroupHierarchy>self.drWB_UserGroupHierarchy;
        // let auditService: AuditService = undefined
        this.SaveProgressProvider.start("Saving " + wbUsrGrpH.USRGRPH_NAME + "(" + wbUsrGrpH.USRGRPH_ID + ")");

        try {
            // Doesn't need to do anything yet
            // All the records are in the store, since they were added through find or createNewRecord.
            // -- We could search the tree if the there is any record where store isn't set.

            if (self.dbContext == undefined) {
                self._bIsSaved = false;
                var sError = "Unable to determine dbContext to Save User Group Hierarchy.";
                self.SaveProgressProvider.exception(sError);
                throw new Error(sError)
            }

            self.SaveOptions = options || {};
            var saveFunction: (esName: string, saveRecords: ESRecord[] | ESRecord, options?: any) => Promise<ESDataStore>
            if (bBatch) {
                saveFunction = self.dbContext.SaveBatch.bind(self.dbContext)
            } else {
                saveFunction = self.dbContext.Save.bind(self.dbContext)
            }

            await self.Validate({})

                if (!self.bIsValidated) {
                    self._bIsSaved = false;

                    self.SaveProgressProvider.finish();
                    return self
                }

                await saveFunction(esWB_User_Group_Hierarchy, self.drWB_UserGroupHierarchy, {})

                if (bBatch) {
                    self.dbContext.addBatchCompleteListener(() => {
                        self._bIsSaved = true;
                    })
                } else {
                    self._bIsSaved = true;
                }

                self.SaveProgressProvider.finish();
                return self;
            }
            catch (err) {
            self.SaveProgressProvider.exception(err)
            return self
        }


    }

    get bIsSaved(): boolean {
        return this._bIsSaved;
    }


    Delete(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(true, options)
    }

    DeleteOnSave(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(false, options)
    }

    private DeleteUsing(bSaveNow: boolean, options?: any): Promise<IBusinessObject> {
        var self = this;
        var wbUsrGrp = <IwbUserGroupHierarchy>self.drWB_UserGroupHierarchy;
        this.DeleteMessageProvider.clearMessages();
        this.DeleteProgressProvider.start("Deleting " + wbUsrGrp.USRGRPH_NAME + "(" + wbUsrGrp.WB_USRGRPH_ID + ")");
        return new Promise<IBusinessObject>((resolve, error) => {

            // 1. Validate if we can delete the User Group Hierarchy

            // 2. If Valid, mark all the records for deletion.
            self.drWB_UserGroupHierarchy.markDeleted()


            if (bSaveNow) {
                self.SaveUsing(false)
                    .then((ignore) => {
                        self._bIsDeleted = true;
                        self.DeleteProgressProvider.finish();
                        resolve(self);

                    })
                    .catch((err) => {
                        this.DeleteProgressProvider.exception(err)
                        resolve(self)
                    })
            } else {
                self._bIsDeleted = true;
                self.DeleteProgressProvider.finish();
                resolve(self);
            }
        });
    }

    get bIsDeleted(): boolean {
        return this._bIsDeleted;
    }

    //</editor-fold>


    Changes(options?: IBusinessObjectChangesOptions): IBusinessObjectChanges {
        let opts = options || {}
        // Set any BO Specific change settings
        return DefaultChanges(this, this.drWB_UserGroupHierarchy, opts)
    }

    //<editor-fold desc = "IRecordResolver Operations">

    static setupRecordResolver(recordResolver: ESRecordResolver, ids: string[] | number[]): Promise<void> {

        return new Promise<void>((resolve, error) => {
            recordResolver.findAllWithRelationships(esWB_User_Group_Hierarchy, ids).then((result) => {
                resolve()
            }).catch((err) => {
                error(err)
            })
        })
    }

    static createRecordResolver(boLoadOptions: any): ESRecordResolver {

        let opts = boLoadOptions || {}
        let dbContext: PAdbContext

        if ('dbContext' in opts) {
            dbContext = opts.dbContext;
        } else {
            dbContext = new PAdbContext({});
        }
        const wrksp_options: CreateOptions = {
            standardConditions: {
                [esWB_User_Group_Hierarchy]: {"DELETED_IND": {"notIn": ['1']}},
            },
            dctIncludeBelongsToNamedRelations: {}
        }

        const aRecResolver = new ESRecordResolver(dbContext, wrksp_options)

        return aRecResolver;

    }

    //</editor-fold>


};
PAEnvironment.registerBusinessObjectClass( UserGroupHierarchyBO, "UserGroupHierarchyBO" ,"User Group Hierarchy")